export default __webpack_public_path__ + "static/media/interreg-logo.857f2052.png";